<template>
  <div>
    <div v-if="!requireAuth || isAuth">
      <router-view></router-view>
    </div>

    <div v-else class="app-root">
      <div>
        <top-header></top-header>
      </div>
      <div class="app-body">
        <side-menu class="sidebar"></side-menu>
        <div class="main" >
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import cache from '../config/cache'

export default {
  name: 'app-main',
  data() {
    return {
      isAuth: false,
      requireAuth: false
    }
  },
  components: {
    topHeader: resolve => require(['./top-header'],resolve),
    sideMenu: resolve => require(['./side-menu'],resolve),
  },

  created() {
    this.getRequireAuth();
    this.getCache();
  },
  methods: {

    getRequireAuth () {
        this.$router.beforeEach((to, from, next) => {
          this.isAuth = to.meta.requireAuth;
          next()
        })
    },

    getCache() {
      this.requireAuth = cache.get('requireAuth');

      cache.get('requireAuth', (data)=>{
        this.requireAuth = data;
      })
    }
  }
}
</script>
<style scoped>
  .app-root {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-height: 100vh;
  }

  .app-body {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    min-height: calc(100vh - 91px)\0\9; 
  }

  .sidebar {
    flex: 0 0 120px;
    background: #F1F3F6;
  }

  .main {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    min-height: calc(100% - 91px);
  }
</style>